import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Button } from 'reactstrap';
import { CSVLink } from 'react-csv';

import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../components/DatatablePagination';
import { addOneDay } from '../../../../../helpers/Utils';

const TicketStatsByCategory = ({ labels, data, fromDate, toDate }) => {
  const [csvData, setCSVData] = useState([]);
  useEffect(() => {
    var tablePrint = [
      {
        r1: '',
        r2: 'Tickets by Category',
      },
      {},
      {
        r1: 'Start Date :' + fromDate,
        r2: 'End Date :' + addOneDay(toDate),
      },
      {},
      {
        r1: 'Category',
        r2: 'Ticket Count',
      },
    ];
    if (data.length > 0) {
      data.map((elem) => {
        tablePrint.push({
          r1: elem.category,
          r2: elem.ticketCount,
        });
      });
    }
    setCSVData(tablePrint);
  }, [data]);
  return (
    <Card>
      <div style={{ padding: '15px' }}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline">
              <IntlMessages id="dashboards.tickets-by-category" />
            </h5>
            <span className="text-muted text-small d-block">
              <IntlMessages id="dashboards.commonticketsubmission" />
            </span>
          </div>
        </div>
        <div className="float-right">
          <CSVLink
            data={csvData}
            headers={[
              { key: 'r1', label: '' },
              { key: 'r2', label: '' },
            ]}
            filename="ticket-by-category.csv"
          >
            <Button color="primary" outline size="xs">
              <IntlMessages id="dashboards.download" />
            </Button>
          </CSVLink>
        </div>
      </div>
      <CardBody>
        <ReactTable
          data={data}
          columns={labels}
          defaultPageSize={5}
          filterable={false}
          showPageJump={true}
          PaginationComponent={DataTablePagination}
          showPageSizeOptions={true}
          defaultSorted={[
            {
              id: 'ticketCount',
              desc: true,
            },
          ]}
        />
      </CardBody>
    </Card>
  );
};

export default TicketStatsByCategory;
